import React, { useState, useEffect } from "react";

const LoadingDots = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 4 ? prev + "." : ""));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center space-y-2">
      {/* Animasi Titik Bergerak */}
      {/* <div className="flex space-x-1">
        <span className="w-2 h-2 bg-gray-500 rounded-full animate-bounce delay-0"></span>
        <span className="w-2 h-2 bg-gray-500 rounded-full animate-bounce delay-200"></span>
        <span className="w-2 h-2 bg-gray-500 rounded-full animate-bounce delay-400"></span>
      </div> */}

      {/* Animasi Loading Teks */}
      <div className="text-lg font-bold text-mo-text">Loading{dots}</div>
    </div>
  );
};

export default LoadingDots;
